import React, { useState, useEffect } from 'react';
import '../styles/Cartoes.css';

const logoBandeiras = {
  mastercard: '💳',
  visa: '🏧',
  elo: '💰',
  amex: '🎫'
};

export default function Cartoes() {
  const [cartoes, setCartoes] = useState([]);
  const [contas, setContas] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    bandeira: 'mastercard',
    numero_final: '',
    limite: '',
    vencimento: '',
    bankAccountId: ''
  });

  useEffect(() => {
    carregarCartoes();
    carregarContas();
  }, []);

  const carregarCartoes = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/bank/cartoes', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setCartoes(data.cartoes || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const carregarContas = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/bank/contas', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setContas(data.contas || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const handleAddOuEditar = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const url = editingId ? `/api/bank/cartoes/${editingId}` : '/api/bank/cartoes';
    const method = editingId ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ ...formData, limite: parseFloat(formData.limite), vencimento: parseInt(formData.vencimento), bankAccountId: formData.bankAccountId ? parseInt(formData.bankAccountId) : null })
      });
      const data = await res.json();
      if (data.success) {
        handleCancelar();
        carregarCartoes();
      }
    } catch (error) { console.error('Erro:', error); }
  };

  const handleEditar = (cartao) => {
    setFormData({
      nome: cartao.nome,
      bandeira: cartao.bandeira,
      numero_final: cartao.numero_final,
      limite: cartao.limite,
      vencimento: cartao.vencimento,
      bankAccountId: cartao.bankAccountId || ''
    });
    setEditingId(cartao.id);
    setShowForm(true);
  };

  const handleDeletar = async (id) => {
    if (!window.confirm('Deletar cartão?')) return;
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/bank/cartoes/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) carregarCartoes();
    } catch (error) { console.error('Erro:', error); }
  };

  const handleCancelar = () => {
    setShowForm(false);
    setEditingId(null);
    setFormData({ nome: '', bandeira: 'mastercard', numero_final: '', limite: '', vencimento: '', bankAccountId: '' });
  };

  return (
    <div className="cartoes-page">
      <h1>💳 Meus Cartões de Crédito</h1>

      <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
        {showForm ? '✕ Cancelar' : '+ Adicionar Cartão'}
      </button>

      {showForm && (
        <form onSubmit={handleAddOuEditar} className="form-card">
          <div className="form-group">
            <label>Nome do Cartão</label>
            <input
              type="text"
              value={formData.nome}
              onChange={(e) => setFormData({...formData, nome: e.target.value})}
              placeholder="Ex: MasterCard Principal"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Bandeira</label>
              <select value={formData.bandeira} onChange={(e) => setFormData({...formData, bandeira: e.target.value})}>
                <option value="mastercard">MasterCard</option>
                <option value="visa">Visa</option>
                <option value="elo">Elo</option>
                <option value="amex">American Express</option>
              </select>
            </div>
            <div className="form-group">
              <label>Últimos 4 Dígitos</label>
              <input
                type="text"
                value={formData.numero_final}
                onChange={(e) => setFormData({...formData, numero_final: e.target.value})}
                placeholder="1234"
                maxLength="4"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Limite (R$)</label>
              <input
                type="number"
                value={formData.limite}
                onChange={(e) => setFormData({...formData, limite: e.target.value})}
                step="0.01"
                required
              />
            </div>
            <div className="form-group">
              <label>Vencimento (dia)</label>
              <input
                type="number"
                value={formData.vencimento}
                onChange={(e) => setFormData({...formData, vencimento: e.target.value})}
                min="1"
                max="31"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Vincular à Conta (Opcional)</label>
            <select value={formData.bankAccountId} onChange={(e) => setFormData({...formData, bankAccountId: e.target.value})}>
              <option value="">Nenhuma conta</option>
              {contas.map(c => (
                <option key={c.id} value={c.id}>{c.nome}</option>
              ))}
            </select>
          </div>

          <div className="form-buttons">
            <button type="submit" className="btn-primary">{editingId ? 'Atualizar' : 'Adicionar'}</button>
            <button type="button" className="btn-secondary" onClick={handleCancelar}>Cancelar</button>
          </div>
        </form>
      )}

      <div className="cartoes-grid">
        {cartoes.map(cartao => (
          <div key={cartao.id} className="cartao-card">
            <div className="cartao-logo">{logoBandeiras[cartao.bandeira]}</div>
            <div className="cartao-info">
              <h3>{cartao.nome}</h3>
              <p className="numero">•••• •••• •••• {cartao.numero_final}</p>
              <p className="conta">{cartao.BankAccount?.nome || 'Sem conta vinculada'}</p>
            </div>
            <div className="cartao-limite">
              <span>Limite</span>
              <p>R$ {parseFloat(cartao.limite).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</p>
            </div>
            <div className="cartao-vencimento">Vence no dia {cartao.vencimento}</div>
            <div className="cartao-actions">
              <button className="btn-small" onClick={() => handleEditar(cartao)}>✏️ Editar</button>
              <button className="btn-small danger" onClick={() => handleDeletar(cartao.id)}>🗑️ Deletar</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
